import { FC, ReactElement } from 'react';

import { Picture } from '../../../../../components';
import { VisualCarouselSlideInterface } from '../../../../../entities/@sections/VisualCarousel/VisualCarousel';
import useResponsiveImages from '../../../../../hooks/useResponsiveImages';

import './HalfWidthVisualCarouselSlideMedia.scss';

export interface HalfWidthVisualCarouselSlideMediaProps extends VisualCarouselSlideInterface {
    className?: string;
}

const HalfWidthVisualCarouselSlideMedia: FC<HalfWidthVisualCarouselSlideMediaProps> = ({
    image,
    responsiveImages,
    className = '',
}): ReactElement => {
    const imageList = image ? [image] : [];
    const responsiveImageList = useResponsiveImages(imageList, responsiveImages);

    const slideImage = responsiveImageList.length > 0
        ? responsiveImageList[0]
        : undefined;

    return (
        <div className={`half-width-visual-carousel-slide-media ${className}`}>
            {slideImage && (
                <Picture
                    {...slideImage.image}
                    hasScaling
                    objectPosition={slideImage.position}
                    className="half-width-visual-carousel-slide-media__picture"
                    imageClassName="half-width-visual-carousel-slide-media__image"
                />
            )}
        </div>
    );
};

export default HalfWidthVisualCarouselSlideMedia;
